const createRegExpFromString = (regex: string) => {
  const regexMatch = String(decodeURIComponent(regex)).match(/\/(.*)\/(.*)/) || "";
  // eslint-disable-next-line
  const pattern = new RegExp(regexMatch[1], regexMatch[2]);

  return pattern;
};

export default createRegExpFromString;
